import React from 'react';

import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//component ui:
import DatePicker from '../../utils/DatePicker';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
    root: {
        height: '100%',
        width: '100%',
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    textArea: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        width: 505,
        height: 72,
    },
    buttonsContainer: {
        marginLeft: 25,
        marginTop: 35,
    },
    divider: {
        margin: 20,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 20px',
        marginBottom: 20,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class EditIncidenciaMaquina extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.incidencia.id ? this.props.incidencia.id : uuidv4(),
            maquinaId: this.props.incidencia.maquinaId
                ? this.props.incidencia.maquinaId
                : this.props.maquinaId,
            fecha: this.props.incidencia.fecha
                ? this.props.incidencia.fecha.slice(0, 10)
                : new Date().toJSON().slice(0, 10),
            incidencia: this.props.incidencia.incidencia
                ? this.props.incidencia.incidencia
                : '',
            usuarioIncidencia: this.props.incidencia.usuarioIncidencia
                ? this.props.incidencia.usuarioIncidencia
                : '',
            fechaDiagnostico: this.props.incidencia.fechaDiagnostico
                ? this.props.incidencia.fechaDiagnostico.slice(0, 10)
                : new Date().toJSON().slice(0, 10),
            diagnostico: this.props.incidencia.diagnostico
                ? this.props.incidencia.diagnostico
                : '',
            usuarioDiagnostico: this.props.incidencia.usuarioDiagnostico
                ? this.props.incidencia.usuarioDiagnostico
                : '',
            fechaResolucion: this.props.incidencia.fechaResolucion
                ? this.props.incidencia.fechaResolucion.slice(0, 10)
                : new Date().toJSON().slice(0, 10),
            resolucion: this.props.incidencia.resolucion
                ? this.props.incidencia.resolucion
                : '',
            usuarioResolucion: this.props.incidencia.usuarioResolucion
                ? this.props.incidencia.usuarioResolucion
                : '',
            maquina: this.props.incidencia.maquina
                ? this.props.incidencia.maquina
                : null,
        };
    }

    //textfield
    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    //checkbox:
    handleBooleanChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.checked });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        {/* <TextField
                            id={'fecha'}
                            label={'Fecha'}
                            placeholder={'Fecha'}
                            type="date2"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            value={this.state.fecha}
                            autoFocus
                            onChange={(event) => this.handleValueChange(event, 'fecha')}
                        /> */}
                        <DatePicker
                            label={'Fecha'}
                            value={this.state.fecha}
                            onChange={event => {
                                if (event && !isNaN(event)) {
                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                    this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fecha')
                                }
                            }}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'usuarioIncidencia'}
                            label={'Usuario Incidencia'}
                            placeholder={'Usuario Incidencia'}
                            margin="normal"
                            value={this.state.usuarioIncidencia}
                            onChange={event =>
                                this.handleValueChange(
                                    event,
                                    'usuarioIncidencia',
                                )
                            }
                        />
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.textArea}>
                        <TextField
                            id={'incidencia'}
                            label={'Incidencia'}
                            multiline
                            rows="2"
                            placeholder={'Incidencia'}
                            margin="normal"
                            value={this.state.incidencia}
                            onChange={event =>
                                this.handleValueChange(event, 'incidencia')
                            }
                        />
                    </FormControl>
                </div>

                <div className={classes.divider}></div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        {/* <TextField
                            id={'fechaDiagnostico'}
                            label={'Fecha Diagnostico'}
                            placeholder={'Fecha Diagnostico'}
                            type="date2"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            value={this.state.fechaDiagnostico}
                            onChange={(event) => this.handleValueChange(event, 'fechaDiagnostico')}
                        /> */}
                        <DatePicker
                            label={'Fecha Diagnostico'}
                            value={this.state.fechaDiagnostico}
                            onChange={event => {
                                if (event && !isNaN(event)) {
                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                    this.handleValueChange(
                                        d.toISOString().slice(0, 10),
                                        'fechaDiagnostico',
                                    )
                                }
                            }}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'usuarioDiagnostico'}
                            label={'Usuario Diagnostico'}
                            placeholder={'Usuario Diagnostico'}
                            margin="normal"
                            value={this.state.usuarioDiagnostico}
                            onChange={event =>
                                this.handleValueChange(
                                    event,
                                    'usuarioDiagnostico',
                                )
                            }
                        />
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.textArea}>
                        <TextField
                            id={'diagnostico'}
                            label={'Diagnostico'}
                            placeholder={'Diagnostico'}
                            multiline
                            rows="2"
                            margin="normal"
                            value={this.state.diagnostico}
                            onChange={event =>
                                this.handleValueChange(event, 'diagnostico')
                            }
                        />
                    </FormControl>
                </div>

                <div className={classes.divider}></div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        {/* <TextField
                            id={'fechaResolucion'}
                            label={'Fecha Resolucion'}
                            placeholder={'Fecha Resolucion'}
                            type="date2"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            value={this.state.fechaResolucion}
                            onChange={(event) => this.handleValueChange(event, 'fechaResolucion')}
                        /> */}
                        <DatePicker
                            label={'Fecha Resolucion'}
                            value={this.state.fechaResolucion}
                            onChange={event => {
                                if (event && !isNaN(event)) {
                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                    this.handleValueChange(d.toISOString().slice(0, 10), 'fechaResolucion')
                                }
                            }}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'usuarioResolucion'}
                            label={'Usuario Resolucion'}
                            placeholder={'Usuario Resolucion'}
                            margin="normal"
                            value={this.state.usuarioResolucion}
                            onChange={event =>
                                this.handleValueChange(
                                    event,
                                    'usuarioResolucion',
                                )
                            }
                        />
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.textArea}>
                        <TextField
                            id={'resolucion'}
                            label={'Resolucion'}
                            placeholder={'Resolucion'}
                            margin="normal"
                            multiline
                            rows="2"
                            value={this.state.resolucion}
                            onChange={event =>
                                this.handleValueChange(event, 'resolucion')
                            }
                        />
                    </FormControl>
                </div>
                <div className={classes.buttonsContainer}>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="secondary"
                        onClick={() => this.props.hideDialog()}
                    >
                        Cerrar
                    </Button>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            const incidencia = {
                                id: this.state.id,
                                maquinaId: this.state.maquinaId,
                                fecha: this.state.fecha,
                                incidencia: this.state.incidencia,
                                usuarioIncidencia: this.state.usuarioIncidencia,
                                fechaDiagnostico: this.state.fechaDiagnostico,
                                diagnostico: this.state.diagnostico,
                                usuarioDiagnostico: this.state
                                    .usuarioDiagnostico,
                                fechaResolucion: this.state.fechaResolucion,
                                resolucion: this.state.resolucion,
                                usuarioResolucion: this.state.usuarioResolucion,
                                maquina: this.state.maquina,
                            };

                            if (this.props.checkIncidenciaFields(incidencia)) {
                                this.props.okHandler(incidencia);
                                this.props.hideDialog();
                            }
                        }}
                    >
                        Guardar
                    </Button>
                </div>
            </div>
        );
    }
}

EditIncidenciaMaquina.propTypes = {
    incidencia: PropTypes.object.isRequired,
    maquinaId: PropTypes.number.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkIncidenciaFields: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditIncidenciaMaquina);
